import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const InvoicesFooter = () => {
  const {count, totalAmount} = useSelector(
    (state) => ({
      count: state.invoices.totalCount,
      totalAmount: state.invoices.totalAmount,
    }),
    shallowEqual
  );

  return <Footer count={count} totalAmount={totalAmount ? totalAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}/>
};
